import { get } from './client.js';

const ws = (wsId) => `/workspaces/${wsId}/analytics`;

/* CRM workspace analytics — all functions accept an optional params object
   forwarded as query string (ownerId, rangeStart, rangeEnd per AnalyticsQueryDto). */
export const getSummary        = (wsId, params = {}) => get(`${ws(wsId)}/pipeline-summary`,  { params });
export const getActivityFeed   = (wsId, params = {}) => get(`${ws(wsId)}/activity-by-type`,  { params });
export const getPipelineHealth = (wsId, params = {}) => get(`${ws(wsId)}/pipeline-by-stage`, { params });
export const getConversions    = (wsId, params = {}) => get(`${ws(wsId)}/sales-funnel`,       { params });
export const getTopDeals       = (wsId, params = {}) => get(`${ws(wsId)}/team-leaderboard`,   { params });
